export default "__VITE_PUBLIC_ASSET__920f8a58__"